import React, { Component } from 'react';
import fetch from '../../support/fetch';
import AuthenticatedTemplate from "../../Components/Templates/Authenticated/index";
import { Card, Grid, Dimmer, Form, Button } from 'tabler-react';
import Input from '../../Components/Playgrond/Input';
import CardAlert from '../../Components/CardAlert';

class ChangePassword extends Component {
    state = {
        showLoader: false,
        alertText: '',
        alertColor: 'danger',
        user: {},
        values: {}
    };

    componentDidMount() {
        this.setState({
            user: JSON.parse(sessionStorage.getItem('ooppah_user_info'))
        })
    };

    onChangeHandler = e => {
        this.setState(prevState => ({
            values: {
                ...prevState.values,
                [e.target.name]: e.target.value
            }
        }))
    };

    submitHandler = e => {
        e.preventDefault();

        this.setState({showLoader: true});

        fetch.obj({
            query: `mutation ChangePassword($password: String!, $password_confirmation: String!) {
                changePassword(password: $password, password_confirmation: $password_confirmation) {
                    id
                }
            }`,
            variables: {
                password: this.state.values.password,
                password_confirmation: this.state.values.password_confirmation,
            }
        })
        .then(res => {
            if (res.hasOwnProperty('errors') && res.errors[0].hasOwnProperty('validation')) {
                const lastErrorKey = Object.keys(res.errors[0].validation)[0];

                this.setState({
                    alertText: res.errors[0].validation[lastErrorKey][0]
                })
            }

            // console.log(res);

            this.setState({
                showLoader: false,
                alertText: 'Senha alterada com sucesso. Você já pode utiliza-la no seu próximo login.',
                alertColor: 'success',
                values: {
                    password: '',
                    password_confirmation: '',
                }
            });
        });
    };

    render() {
        return (
            <AuthenticatedTemplate title="Alterar Senha">
                <Grid.Row>
                    <Grid.Col md="7">
                        <form method="POST" onSubmit={this.submitHandler} autoComplete="off">
                            <Card>
                                <Card.Body>
                                    <CardAlert color={this.state.alertColor} >{this.state.alertText}</CardAlert>
                                    <Dimmer active={this.state.loading} loader={this.state.loading}>
                                        <p className="lead">
                                            Para alterar sua senha atual, entre com a sua nova senha. Em seguida,{' '}
                                            basta confirmá-la novamente e clicar em "Alterar minha Senha".
                                        </p>
                                        <Form.Group label="Nova Senha">
                                            <Input
                                                name="password"
                                                type="password"
                                                required
                                                onChange={this.onChangeHandler}
                                                disabled={this.state.showLoader}
                                                value={this.state.values.password}
                                            />
                                        </Form.Group>

                                        <Form.Group label="Nova Senha - Confirmação">
                                            <Input
                                                name="password_confirmation"
                                                required
                                                type="password"
                                                value={this.state.values.password_confirmation}
                                                onChange={this.onChangeHandler}
                                                disabled={this.state.showLoader}
                                            />
                                        </Form.Group>

                                        <Button
                                            outline={!this.state.showLoader}
                                            color="info"
                                            block size="lg"
                                            className="mt-6"
                                            loading={this.state.showLoader}
                                            disabled={this.state.showLoader}
                                        >
                                            Alterar minha Senha
                                        </Button>
                                    </Dimmer>
                                </Card.Body>
                            </Card>
                        </form>
                    </Grid.Col>
                </Grid.Row>
            </AuthenticatedTemplate>
        );
    }
}

export default ChangePassword;
